import PropTypes from 'prop-types';

export function Loader({ title = 'Loading...' }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center py-10">
      <style>
        {`
          @keyframes big-bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-20px); } /* Increase this for bigger bounce */
          }
        `}
      </style>

      {/* Loader balls */}
      <div className="flex gap-3 mb-4">
        <div
          className="h-4 w-4 rounded-full bg-orange-600"
          style={{ animation: 'big-bounce 0.8s infinite' }}
        ></div>

        <div
          className="h-4 w-4 rounded-full bg-orange-500"
          style={{ animation: 'big-bounce 0.8s infinite 0.15s' }}
        ></div>

        <div
          className="h-4 w-4 rounded-full bg-orange-400"
          style={{ animation: 'big-bounce 0.8s infinite 0.3s' }}
        ></div>
        <div
          className="h-4 w-4 rounded-full bg-orange-300"
          style={{ animation: 'big-bounce 0.8s infinite 0.45s' }}
        ></div>
      </div>

      {/* Title */}
      <div className="text-gray-700 text-md font-medium animate-pulse">
        {title}
      </div>
    </div>
  );
}

Loader.propTypes = {
  title: PropTypes.string,
};
